import React from 'react'
import styled from 'styled-components'
import {EmailIcon, FbIcon, TwitterIcon} from 'components/static/icons'
import Color from 'constants/colors'

const Center = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 70px;
	text-align: center;
	margin-top: 30px;
`;

const IconContainer = styled.a`
	display: block;
	height: 40px;
	width: 40px;
	padding: 5px;
	box-sizing: border-box;
	border-radius: 4px;
	background-color: ${Color('pink')};
	margin: 0 5px;
	@media not all and (hover: none) {
		&:hover{
			background-color: ${Color('pink',0,-10)};
		}
	}
`;

const Contain = styled.div`
	height: 100%;
	align-items: center;
	display: flex;
	justify-content: center;
	object-fit: contain;
`;

const SocialMediaButtons = () => {
	
	const twitterUrl = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fbythebay.cool%2Felection%2F&text=SF+and+CA+voted+on+some+rad+races+and+propositions.+Check+out+@bythebaydotcool’s+election+result";
	const facebookUrl = "https://www.facebook.com/dialog/share?app_id=1134187086655814&display=popup&href=https%3A%2F%2Fbythebay.cool%2Felection%2F";
	const emailUrl = "mailto:?subject=voter guide&body=Check out this nonpartisan voter guide https://bythebay.cool/";

	return(
    <Center>
    	<h4>And helping your friends vote is .cool too</h4>
    	<Icon url={facebookUrl} img={<FbIcon/>}/>
    	<Icon url={twitterUrl} img={<TwitterIcon/>}/>
    	<Icon url={emailUrl} img={<EmailIcon/>}/>
		</Center>
	);
}

const Icon = (props) => {
	return(
  	<IconContainer
  		target="_blank" 
  		rel="noopener noreferrer" 
  		href={props.url} 
  	>
  		<Contain>{props.img}</Contain>
  	</IconContainer>
	);
}

export default SocialMediaButtons;


// WEBPACK FOOTER //
// ./src/components/interactive/socialMedia/SocialMediaButtons.js